module.exports = __webpack_public_path__ + "img/w3_sort_black.94dff88a.png";